import React, { useEffect, useMemo, useRef, useState } from 'react';
import './documents-approval-form.css';
import { Button, Card,Drawer,Form,Row,Col,Alert,Select, Anchor,Spin, Radio,Tabs, Popconfirm, Switch, Divider, Input, message} from 'antd';
import Table, { ColumnProps, ColumnsType } from 'antd/lib/table';
import { DocumentationData } from '../data';
import {SaleOrderService} from '@gtpl/shared-services/sale-management';
import { BookContainerDto, DocumentsEnum, DocumentsUploadData } from '@gtpl/shared-models/logistics';
import { AlertMessages} from '../../../../../../shared-utils/alert-messages/src';
import {RightSquareOutlined,SearchOutlined  } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { EmployeeRolesEnum } from '@gtpl/shared-models/common-models';
import { ContainerRegisterService } from '@gtpl/shared-services/logistics';
import {UnitcodeService} from '@gtpl/shared-services/masters'
import { render } from 'react-dom';
import { PlantIdRequest } from '@gtpl/shared-models/masters';

export interface DocumentsApprovalFormProps {
  formData:[];
  updateStatus:(approvalData: any,val:string) => void;
  submitStatus:(submitStatus:any)=>void;

}

export function DocumentsApprovalForm(
  props: DocumentsApprovalFormProps
) {
  const options = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];
  const [page, setPage] = React.useState(1);
  const { TabPane } = Tabs;
  const [searchText, setSearchText] = useState(''); 
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [documentationData, setDocumentationData] = useState<DocumentsUploadData[]>([])
  const [defaultTabPane, setDefaultTabPane] = useState<string>("1")
  const saleOrderService = new SaleOrderService;
  const unitCodeService = new UnitcodeService();
  const [years,setYears] = useState<any[]>([])
  const saleService = new SaleOrderService();
  const [form] = Form.useForm();
  const containerRService = new ContainerRegisterService();
  const [itemNoValues, setItemNoValues] = useState({});
const [itemsState, setItemsState] = useState([])


const onFinish = (value: string, record) => {
  const updatedValue = form.getFieldValue(record.saleOrderId+'freightAfterShipment');
  const updatedItem = {
    ...record,
    freightAfterShipment: value,
  };

  containerRService.documentApprovelOpenShipment(updatedItem).then(res => {
    console.log(res, "resssssssss");
    
    if (res.status) {
      AlertMessages.getSuccessMessage(res.internalMessage);
      setTimeout(() => {
        message.success('Submitted successfully');
      }, 500);
    }   
  }).catch(err => {
    AlertMessages.getErrorMessage(err.message);
  });
};

const handleItemNoChange = (value, record) => {
  onFinish(value, record);
};

  
  // const handleItemNoChange = (value, record) => {
  //   // Assuming 'containerId' is the unique identifier for the record
  //   const updatedItem = {
  //     ...record,
  //     [record.key]: value,
  //   };
  
    // Create a new instance of BookContainerDto with the updated item
  //   const updatedItems: BookContainerDto = {
  //     ...itemsState, // Assuming 'items' is the current state or values you're tracking
  //     [record.containerId]: updatedItem,
  //   };
  
  //   // Call onFinish with the updated items
  //   onFinish(updatedItems);
  // };
  




  const getColumnSearchProps = (dataIndex:string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select(),100);   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
        // searchText
      ) :text
      )
      : null
     
  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };
  

  // /**
  //  * 
  //  * @param pagination 
  //  * @param filters 
  //  * @param sorter 
  //  * @param extra 
  //  */
  // const onChange=(pagination, filters, sorter, extra)=> {
  //   console.log('params', pagination, filters, sorter, extra);
  // }

  useEffect(() => {
    getAllSaleOrdersDocumentsData();
    getAllFinancialYear();
  //   if (Number(localStorage.getItem('unit_id')) != 5) {
  //     form.setFieldsValue({ unitcodeId: Number(localStorage.getItem('unit_id')) })
  // }
  }, [])

  const getAllSaleOrdersDocumentsData= async () => {
    // const plantId = Number(localStorage.getItem('unit_id'));
    // console.log(plantId)
    const financialYear = form.getFieldValue('financialYear')
    const unitcodeId = Number(localStorage.getItem('unit_id'));
    const req = new PlantIdRequest(Number(unitcodeId),financialYear);
    unitCodeService.getPlantDetailsById(req).then(response=>{
      if(response.status){

        const unitcodeId = response.data.companyId
        const req = new PlantIdRequest(unitcodeId,financialYear);

    saleOrderService.getAllSoDocumentsInfo(req).then(res => {
      if (res.status) 
      
      {
        console.log(res.data);
        setDocumentationData(res.data);
      } else {
        if (res.intlCode) {
          setDocumentationData([]);
            AlertMessages.getErrorMessage(res.internalMessage);
        } else {
         AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setDocumentationData([]);
    })
  }else{
    AlertMessages.getErrorMessage('No Data found for this User');
  }
})
  }
  const getAllFinancialYear  = () => {
    saleService.getAllFinancialYear().then(res => {
      if (res.status) {
        setYears(res.data);
      } else {
        if (res.intlCode) {
          setYears([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setYears([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  const submitApproval= (record:DocumentsUploadData,key:string) => {
    console.log(record);
    console.log(key);
    if(key == "approverOneStatusUploaded"){
      record.approverOneStatusUploaded=record.approverOneStatusUploaded?false:true;
      record.approverTwoStatusUploaded=record.approverTwoStatusUploaded?false:true;
    }
    saleOrderService.approveDocument(record).then(res => {
      console.log(res.internalMessage);
      if (res.status) 
      {
        console.log(res.data);
        // setDocumentationData(res.data);
        AlertMessages.getSuccessMessage(res.internalMessage);
        getAllSaleOrdersDocumentsData();
      } else {
        if (res.intlCode) {
          setDocumentationData([]);
            AlertMessages.getErrorMessage(res.internalMessage);
            getAllSaleOrdersDocumentsData();
        } else {
         AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setDocumentationData([]);
    })
  }





  const updateDocumentStatus= (documentsApprovalId:number,saleOrderId:number,documentName:DocumentsEnum, status:boolean,key) => {
    console.log(documentsApprovalId);
    console.log(saleOrderId);
    console.log(documentName);
    console.log(status);
    saleOrderService.updateDocumentInfo({documentsApprovalId,saleOrderId,documentName,status}).then(res => {
      if (res.status) 
      {
        console.log(res.data);
        AlertMessages.getSuccessMessage(res.internalMessage);
        // setDocumentationData(res.data);
        getAllSaleOrdersDocumentsData();
      } else {
        if (res.intlCode) {
          setDocumentationData([]);

            AlertMessages.getErrorMessage(res.internalMessage);
        } else {
         AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setDocumentationData([]);
    })
    if(key==="approverOneStatusUploaded"){
      setDefaultTabPane("2");
    }else if(key==="approverTwoStatusUploaded"){
      setDefaultTabPane("3");
    }
  }

  console.log(defaultTabPane,"hello ")
  /**
   * Open & Completed columns
   */




  const freightAfsChange = (id: string, val: string) => {
    itemsState[id] = val
    console.log(id);
    console.log(val);
    console.log('---------------------------');
    // update var to state against to id 
  }
  // console.log(defaultTabPane,'oooooooooo');
  
  const Columns:ColumnProps<any>[] = [
    {
      title:'SNo',
      dataIndex:'saleId',
      width: '180',
      fixed: 'left',
      align:'left',
      render: (text, object, index) => (page-1) * 10 +(index+1)
      
    },
    {
      title: 'Customer PO',
      dataIndex: 'saleOrderNumber',
      key: 'saleOrderNumber',
      // align:'left',
      width: 150,
      sorter: (a, b) => a.saleOrderId- b.saleOrderId,
      sortDirections: ['descend', 'ascend'], 
      ...getColumnSearchProps('saleOrderNumber'),
    },
    {
      title: 'Invoice Number',
      dataIndex: 'invoiceNumber',
      key: 'invoiceNumber',
      // align:'left',
      width: 150,
      sorter: (a, b) => a.invoiceNumber- b.invoiceNumber,
      sortDirections: ['descend', 'ascend'], 
      ...getColumnSearchProps('invoiceNumber'),
    },
    {
      title: 'BL Draft',
      key: 'bLDraftUploaded',
      align:'center',
      width:'150',
      render: (text, rowData) => (<>{rowData.bLDraftUploaded===true?'Yes':'No'}</>)

    },  
   
    {
      title: 'SIMP',
      key: 'sIMPUploaded',
      align:'center',
      width:'150',
      render: (text, rowData) => (<>{rowData.sIMPUploaded===true?'Yes':'No'}</>)
    }, 
    {
      title: 'Certificate Of Origin',
      key: 'certificateOfOriginUploaded',
      align:'center',
      width:'150',
      render: (text, rowData) => (<>{rowData.certificateOfOriginUploaded===true?'Yes':'No'}</>)
    },    
    {
      title: 'Declaration Of Shrimp',
      key: 'declarationOfShrimpUploaded',
      align:'center',
      width:'150',
      render: (text, rowData) => (<>{rowData.declarationOfShrimpUploaded===true?'Yes':'No'}</>)
    },  
    {
      title: 'Health Certificate',
      key: 'healthCertificateUploaded',
      align:'center',
      width:'150',
      render: (text, rowData) => (<>{rowData.healthCertificateUploaded===true?'Yes':'No'}</>)
    },
    {
      title: 'Survey Report',
      key: 'surveyReportUploaded',
      align:'center',
      width:'150',
      render: (text, rowData) => (<>{rowData.surveyReportUploaded===true?'Yes':'No'}</>)
    }, 
    {
      title: 'OBL',
      key: 'oblUploaded',
      align:'center',
      width:'150',
      render: (text, rowData) => (<>{rowData.oblUploaded===true?'Yes':'No'}</>)

    },  
    {
      title: 'ISF Worksheet',
      key: 'iSFWorksheetUploaded',
      align:'center',
      width:'150',
      render: (text, rowData) => (<>{rowData.iSFWorksheetUploaded===true?'Yes':'No'}</>)
    },  
    
   
    
    {
      title: 'Approval?',
      key: 'Id',
      align:'center',
      width:'150',
      fixed:'right',
      render: (text, rowData) => (<>{rowData.approverOneStatusUploaded===true?'Yes':'No'}</>)
    },
    // {
    //   title: 'Approval Two?',
    //   key: 'Id',
    //   align:'center',
    //   width:'150',
    //   fixed:'right',
    //   render: (text, rowData) => (<>{rowData.approverTwoStatusUploaded===true?'Yes':'No'}</>)
    // },
    
//  {
//   title: 'Freight After Shipment',
//   key: 'freightAfterShipment',
//   align:'center',
//   width:'250',
//   fixed:'right',
//   render: (index, record:{[key:string]:any}) => (
// <>
//    <Input
//             type="text"
//             placeholder="Enter Shipment value"
//             style={{ height: '40px', width: '100%' }}
//             onChange = {e => freightAfsChange(record.saleOrderId, e.target.value)}
//             // name={record.saleOrderId+'freightAfterShipment'}
//           />
//           <Button
//             type="primary"
//             style={{ marginTop: '10px' }}
//             onClick={e => updateRecord(record.saleOrderId, record)}
//           >
//             Submit
//           </Button></>

//   ),
// }

  ];
  const StatusColumns: ColumnProps<any>[] = useMemo(() => {
    let additionalColumns: ColumnProps<any>[] = [];    
    if (defaultTabPane === '1') {
      additionalColumns = [{
        title: 'Freight After Shipment',
        key: 'freightAfterShipment',
        width: 250,
        fixed: 'right' as 'right',
        render: (_, record) => (
          <>
            <Input
              type="text"
              placeholder="Enter Shipment value"
              style={{ height: '40px', width: '100%' }}
              onChange={e => freightAfsChange(record.saleOrderId, e.target.value)}
            />
            <Button
              type="primary"
              style={{ marginTop: '10px' }}
              onClick={() => updateRecord(record.saleOrderId, record)}
            >
              Submit
            </Button>
          </>
        ),
      }];
      console.log(defaultTabPane,"testing1")

    } else if (defaultTabPane === '4') {
      additionalColumns = [{
        title: 'Freight After Shipment',
        key: 'frieght',
        // render:(_, record)=>(
        //   record.frieght
        // ),
        dataIndex:"freight",
        width: 250,
        render: (value) => (
          <span style={{ color: value > 0 ? 'green' : 'inherit' }}>
            <b>{value}</b>
          </span>
        ),
      }];
      console.log(defaultTabPane,"testing2")
    } 
    
   
    
    console.log(additionalColumns, 'oooooooooooo');
    return [...Columns, ...additionalColumns];
  }, [defaultTabPane]);
  
  const updateRecord = (id: number, record) => {
    const userEnteredVal = itemsState[id];
    record.freightAfterShipment = userEnteredVal;
    containerRService.documentApprovelOpenShipment(record).then(res => {
      if (res.status) {
        AlertMessages.getSuccessMessage(res.internalMessage);
        setTimeout(() => {
          message.success('Submitted successfully');
        }, 500);
      }   
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    });
  };
  

  const columns = (key:string) => {
    console.log(key);

    /**
     * Approval One & Two Columns
     */
  const ApprovalColumns:ColumnProps<any>[] = [
    {
      title:'SNo',
      dataIndex:'saleId',
      width: '150',
      fixed: 'left',
      align:'center',
      render: (text, object, index) => (page-1) * 10 +(index+1)
      
    },
    {
      title: 'SO Number',
      dataIndex: 'saleOrderNumber',
      key: 'saleOrderNumber',
      // align:'left',
      width: 150,
      sorter: (a, b) => a.saleOrderId- b.saleOrderId,
      sortDirections: ['descend', 'ascend'], 
      ...getColumnSearchProps('saleOrderNumber'),

    },
    {
      title: 'Invoice Number',
      dataIndex: 'invoiceNumber',
      key: 'invoiceNumber',
      // align:'left',
      width: 150,
      sorter: (a, b) => a.invoiceNumber- b.invoiceNumber,
      sortDirections: ['descend', 'ascend'], 
      ...getColumnSearchProps('invoiceNumber'),
    },
   
    {
      title: 'BL Draft',
      key: 'bLDraftUploaded',
      align:'center',
      width:'150',
      render: (text, rowData,index) => ( 
        <Radio.Group
          options={options}
          onChange={(e)=>updateDocumentStatus(rowData.documentsApprovalId,rowData.saleOrderId,DocumentsEnum.BL_DRAFT,e.target.value,key)}
          value={rowData.bLDraftUploaded}
          optionType="button"
          buttonStyle="solid"
          style={{ display: 'contents'}}
          size='middle'   />
      ),
    },  
    {
      title: 'SIMP',
      key: 'sIMPUploaded',
      align:'center',
      width:'150',
      render: (text, rowData,index) => ( 
        <Radio.Group
          options={options}
          onChange={(e)=>updateDocumentStatus(rowData.documentsApprovalId,rowData.saleOrderId,DocumentsEnum.SIMP,e.target.value,key)}
          value={rowData.sIMPUploaded}
          optionType="button"
          buttonStyle="solid"
          style={{ display: 'contents'}}
          size='middle'   />
      ),
    },  
    {
      title: 'Certificate Of Origin',
      key: 'certificateOfOriginUploaded',
      align:'center',
      width:'150',
      render: (text, rowData,index) => ( 
        <Radio.Group
          options={options}
          onChange={(e)=>updateDocumentStatus(rowData.documentsApprovalId,rowData.saleOrderId,DocumentsEnum.CERTIFICATE_OF_ORIGIN,e.target.value,key)}
          value={rowData.certificateOfOriginUploaded}
          optionType="button"
          buttonStyle="solid"
          style={{ display: 'contents'}}
          size='middle'   />
      ),
    },  
    {
      title: 'Declaration Of Shrimp',
      key: 'declarationOfShrimpUploaded',
      align:'center',
      width:'150',
      render: (text, rowData,index) => ( 
        <Radio.Group
          options={options}
          onChange={(e)=>updateDocumentStatus(rowData.documentsApprovalId,rowData.saleOrderId,DocumentsEnum.DECLARATION_OF_SHRIMP,e.target.value,key)}
          value={rowData.declarationOfShrimpUploaded}
          optionType="button"
          buttonStyle="solid"
          style={{ display: 'contents'}}
          size='middle'   />
      ),
    }, 
    {
      title: 'Health Certificate',
      key: 'healthCertificateUploaded',
      align:'center',
      width:'150',
      render: (text, rowData,index) => ( 
        <Radio.Group
          options={options}
          onChange={(e)=>updateDocumentStatus(rowData.documentsApprovalId,rowData.saleOrderId,DocumentsEnum.HEALTH_CERTIFICATE,e.target.value,key)}
          value={rowData.healthCertificateUploaded}
          optionType="button"
          buttonStyle="solid"
          style={{ display: 'contents'}}
          size='middle'   />
      ),
    },   
    {
      title: 'Survey Report',
      key: 'surveyReportUploaded',
      align:'center',
      width:'150',
      render: (text, rowData,index) => ( 
        <Radio.Group
          options={options}
          onChange={(e)=>updateDocumentStatus(rowData.documentsApprovalId,rowData.saleOrderId,DocumentsEnum.SURVEY_REPORT,e.target.value,key)}
          value={rowData.surveyReportUploaded}
          optionType="button"
          buttonStyle="solid"
          style={{ display: 'contents'}}
          size='middle'   />
      ),
    },   
     
    {
      title: 'OBL',
      key: 'oblUploaded',
      align:'center',
      width:'150',
      render: (text, rowData,index) => ( 
        <Radio.Group
          options={options}
          onChange={(e)=>updateDocumentStatus(rowData.documentsApprovalId,rowData.saleOrderId,DocumentsEnum.OBL,e.target.value,key)}
          value={rowData.oblUploaded}
          optionType="button"
          buttonStyle="solid"
          style={{ display: 'contents'}}
          size='middle'   />
      ),
    },  
    {
      title: 'ISF Worksheet',
      key: 'iSFWorksheetUploaded',
      align:'center',
      width:'150',
      render: (text, rowData,index) => ( 
        <Radio.Group
          options={options}
          onChange={(e)=>updateDocumentStatus(rowData.documentsApprovalId,rowData.saleOrderId,DocumentsEnum.ISF_Worksheet,e.target.value,key)}
          value={rowData.iSFWorksheetUploaded}
          optionType="button"
          buttonStyle="solid"
          style={{ display: 'contents'}}
          size='middle'   />
      ),
    },  
    
  ]
  const ApproverOne:ColumnProps<any>[] = [
    {
      title:`Approve`,
      dataIndex: 'Approve',
      fixed:'right',
      render: (text, rowData) => (
        <span>         
          <Divider type="vertical" />
            <Popconfirm onConfirm={e =>{submitApproval(rowData,key);}}
            title={
              rowData.approverOneStatusUploaded
                ? 'Are you sure to DisApprove One Documents ?'
                :  'Are you sure to Approve One Documents ?'
            }
          >
            <Switch  size="default"
                className={ rowData.approverOneStatusUploaded ? 'toggle-activated' : 'toggle-deactivated' }
                checkedChildren={<RightSquareOutlined type="check" />}
                unCheckedChildren={<RightSquareOutlined type="close" />}
                checked={rowData.approverOneStatusUploaded}
              />
            
          </Popconfirm>
        </span>
      )
    }
  ];
  const ApproverTwo:ColumnProps<any>[] = [
    {
      title:`Approve`,
      dataIndex: 'Approve',
      fixed:'right',
      render: (text, rowData) => (
        <span>         
          <Divider type="vertical" />
            <Popconfirm onConfirm={e =>{submitApproval(rowData,key);}}
            title={
              rowData.approverTwoStatusUploaded
                ? 'Are you sure to DisApprove Two Documents ?'
                :  'Are you sure to Approve Two Documents ?'
            }
          >
            <Switch  size="default"
                className={ rowData.approverTwoStatusUploaded ? 'toggle-activated' : 'toggle-deactivated' }
                checkedChildren={<RightSquareOutlined type="check" />}
                unCheckedChildren={<RightSquareOutlined type="close" />}
                checked={rowData.approverTwoStatusUploaded}
              />
            
          </Popconfirm>
        </span>
      )
    }
  ];

  

  if( key === "approverOneStatusUploaded"){
    console.log('approverOneStatusUploaded')

    return [...ApprovalColumns,...ApproverOne];
  }
  else if(key === "approverTwoStatusUploaded"){
    console.log('approverTwoStatusUploaded')
    return [...ApprovalColumns,...ApproverTwo];
  }
else {
    return ApprovalColumns;

  }
}

  const onChange=(pagination, filters, sorter, extra)=> {
    console.log('params', pagination, filters, sorter, extra);
  }
  useEffect(() => {
    // setDocumentationData(DocumentationData);
    console.log(documentationData);
  }, [])
  function callback(key) {
    console.log(key);
  }
  const onReset = () => {
    form.resetFields();
    getAllSaleOrdersDocumentsData();
  };
  return (
    <>
    <Card title={<span style={{color:'white'}}>Documentation Approval</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }}>
      <Form form={form} layout={'vertical'}  onFinish={getAllSaleOrdersDocumentsData} >
            <Row gutter={[24, 24]} style={{rowGap:'0px'}}>
           
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                                                  <Form.Item name="financialYear" label="Financial Year">
                                                    <Select
                                                      showSearch
                                                      placeholder="Select Financial Year"
                                                      optionFilterProp="children"
                                                      filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                      allowClear
                                                    >
                                                      {years.filter(year => year.financialYear !== null).map((y: any) => (
                                                        <Select.Option key={y.financialYear} value={y.financialYear}>
                                                          {y.financialYear}
                                                        </Select.Option>
                                                      ))}
                                                    </Select>
                                                  </Form.Item>
                                                </Col>
              <Col style={{ paddingLeft:'10px', marginTop:'30px' }}>
                <Form.Item >
                  <Button type="primary" htmlType="submit">
                    Get Details
                  </Button>
                </Form.Item>
              </Col>
              <Col style={{ paddingLeft:'10px', marginTop:'30px' }}>
                <Form.Item>
                  <Button htmlType="button" onClick={onReset}>
                    Reset
                  </Button>

                </Form.Item>
              </Col>
               </Row>
                </Form>
      <div className="card-container">
      <Tabs type={'card'} tabPosition={'top'}   onChange={(key) => setDefaultTabPane(key)} defaultActiveKey={defaultTabPane}>
      {
      <TabPane key="1" tab={<span style={{ color: "#f5222d" }}>{'Open: ' + (documentationData.filter(rec=> rec.approverOneStatusUploaded== false || rec.approverTwoStatusUploaded== false).length)}</span>}>
        <Table
          key={defaultTabPane}
          rowKey={record => record.containerId}
          columns={StatusColumns}
          dataSource={documentationData.filter(rec=> rec.approverOneStatusUploaded== false || rec.approverTwoStatusUploaded== false)}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          size="large"
          scroll={{ x:true }}
          bordered/>
      </TabPane>
      }
       {
      <TabPane key="2" tab={<span style={{ color: "#08979c" }}>{'Approval Pendings: ' + (documentationData.filter(el => el.approverOneStatusUploaded== false).length)}</span>}>
        <Table
          key={defaultTabPane}
          rowKey={record => record.containerId}
          columns={documentationData.length==0?null:columns("approverOneStatusUploaded")}
          dataSource={documentationData.filter(rec=> rec.approverOneStatusUploaded== false)}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          size="large"
          scroll={{ x:true}}
          bordered/>
      </TabPane>
      }
       {
      // <TabPane key="3" tab={<span style={{ color: "#faad14" }}>{'Approval Two Pendings: ' + (documentationData.filter(el => el.approverTwoStatusUploaded== false && el.approverOneStatusUploaded == true).length)}</span>}>
      // <Table
      //     key={defaultTabPane}
      //     rowKey={record => record.documentsApprovalId}
      //     columns={documentationData.length==0?null:columns("approverTwoStatusUploaded")}
      //     dataSource={documentationData.filter(rec=> rec.approverOneStatusUploaded== true && rec.approverTwoStatusUploaded == false)}
      //     pagination={{
      //       onChange(current) {
      //         setPage(current);
      //       }
      //     }}
      //     size="large"
      //     scroll={{ x:true }}
      //     bordered/>
      // </TabPane>
      }
      {
      <TabPane key="3" tab={<span style={{ color: "#52c41a" }}>{'Completed: ' + (documentationData.filter(el => el.approverTwoStatusUploaded== true).length)}</span>}>
        <Table
          key={defaultTabPane}
          rowKey={record => record.containerId}
          columns={StatusColumns}
          dataSource={documentationData.filter(rec=> rec.approverOneStatusUploaded== true) && documentationData.filter(rec=> rec.approverTwoStatusUploaded== true)}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          size="large"
          scroll={{ x:true }}
          bordered/>
      </TabPane>
      }
    </Tabs>
      </div>
    </Card>
  </>
  );
}

export default DocumentsApprovalForm;
